import LineEyeIcon from 'LuxKit/Icons/line/LineEyeIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const ViewsBanner = styled(Group)`
  padding: ${rem(8)};
  color: ${props => props.theme.palette.highlight.tertiary.normalForeground};
  background-color: ${props => props.theme.palette.highlight.tertiary.lightBackground};
`

interface Props {
  className?: string;
  offer: App.Offer | App.BundleOffer | App.BedbankOffer
}

function OfferViewsUrgencyBanner(props: Props) {
  const { offer, className } = props
  const views = offer.stats.views

  return <ViewsBanner className={className} direction="vertical" horizontalAlign="center" verticalAlign="center">
    <CaptionTextBlock variant="medium" weight="bold" startIcon={<LineEyeIcon />}>
      Viewed <FormatDecimal
        value={views}
        notation={views > 10000 ? 'compact' : undefined}
        maximumFractionDigits={views > 10000 ? 1 : undefined}
      /> times in 3 days
    </CaptionTextBlock>
  </ViewsBanner>
}

export default OfferViewsUrgencyBanner
